import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { Patient, PatientListDto, CreatePatientDto, UpdatePatientDto, PagedResult } from '../types/patient.types';

export interface GetPagedPatientsParams {
  pageNumber?: number;
  pageSize?: number;
  searchQuery?: string;
  sortBy?: string;
  sortDescending?: boolean;
}

export const patientsApi = {
  getAll: async (): Promise<PatientListDto[]> => {
    const response = await apiClient.get<PatientListDto[]>(API_ENDPOINTS.PATIENTS);
    return response.data;
  },

  getPaged: async (params: GetPagedPatientsParams): Promise<PagedResult<PatientListDto>> => {
    // Clean up params - remove undefined values and ensure proper types
    const cleanParams: Record<string, string | number> = {};
    
    if (params.pageNumber !== undefined) {
      cleanParams.pageNumber = params.pageNumber;
    }
    if (params.pageSize !== undefined) {
      cleanParams.pageSize = params.pageSize;
    }
    if (params.searchQuery !== undefined && params.searchQuery !== null && params.searchQuery !== '') {
      cleanParams.searchQuery = params.searchQuery;
    }
    if (params.sortBy !== undefined && params.sortBy !== null && params.sortBy !== '') {
      cleanParams.sortBy = params.sortBy;
    }
    if (params.sortDescending !== undefined) {
      cleanParams.sortDescending = params.sortDescending ? 'true' : 'false';
    }
    
    const response = await apiClient.get<PagedResult<PatientListDto>>(API_ENDPOINTS.PAGED_PATIENTS, {
      params: cleanParams,
    });
    return response.data;
  },

  getById: async (id: number): Promise<Patient> => {
    const response = await apiClient.get<Patient>(API_ENDPOINTS.PATIENT_BY_ID(id));
    return response.data;
  },

  search: async (query: string): Promise<PatientListDto[]> => {
    const response = await apiClient.get<PatientListDto[]>(API_ENDPOINTS.SEARCH_PATIENTS, {
      params: { query },
    });
    return response.data;
  },

  create: async (data: CreatePatientDto): Promise<Patient> => {
    const response = await apiClient.post<Patient>(API_ENDPOINTS.PATIENTS, data);
    return response.data;
  },

  update: async (id: number, data: UpdatePatientDto): Promise<Patient> => {
    const response = await apiClient.put<Patient>(API_ENDPOINTS.PATIENT_BY_ID(id), data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.PATIENT_BY_ID(id));
  },
};

